<template>
  <v-menu :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        v-on="on"
      >
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item v-if="!isRascunho(item)"
                   :disabled="!isEditavel(item)"
                   @click="goToEditRequisicao(item)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Editar</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!isRascunho(item)" @click="onClickCopy(item)">
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Copiar
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="!isRascunho(item) && hasModuleGerenciaOuRequisicao"
                   :disabled="isCancelada(item)"
                   @click="onClickCancelar(item)">
        <v-list-item-icon>
          <v-icon>mdi-close</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Cancelar
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho(item)" @click="goToEditRequisicaoRascunho(item)">
        <v-list-item-icon>
          <v-icon>mdi-pencil</v-icon>
        </v-list-item-icon>
        <v-list-item-content>Editar rascunho</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="isRascunho(item)" @click="onClickDelete(item)">
        <v-list-item-icon>
          <v-icon>mdi-delete</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          Remover rascunho
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <px-confirm-dialog ref="confirm"/>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import { SituacaoRequisicao } from 'px-business-components';

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      loadingLink: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasModuleGerencia', 'hasRoleRequisicao']),
    isRascunho() {
      return item => SituacaoRequisicao.keys.RASCUNHO.key === item.situacao;
    },
    isEditavel() {
      return item => SituacaoRequisicao.keys.RECEBIDA.key === item.situacao;
    },
    isCancelada() {
      return item => SituacaoRequisicao.keys.CANCELADA.key === item.situacao;
    },
    hasModuleGerenciaOuRequisicao() {
      return this.hasModuleGerencia || this.hasRoleRequisicao;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
    remove(item) {
      this.$emit('remove', item);
    },
    goToEditRequisicaoRascunho(item) {
      this.$router.push({
        name: 'main.requisicoes.edicao',
        params: {
          id: item.id,
          isRascunho: true,
          isCopy: false,
        },
      });
    },
    goToEditRequisicao(item) {
      this.$router.push({
        name: 'main.requisicoes.edicao',
        params: {
          id: item.id,
          isRascunho: false,
          isCopy: false,
        },
      });
    },
    onClickDelete(item) {
      this.$refs.confirm.open('Você deseja remover este rascunho?',
        'A solicitação será removida e esta operação não pode ser desfeita.',
        { width: 450 })
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.remove(item);
        });
    },
    onClickCopy(item) {
      this.$router.push({
        name: 'main.requisicoes.cadastro',
        params: {
          id: item.id,
          isRascunho: false,
          isCopy: true,
        },
      });
    },
    onClickCancelar(item) {
      this.$emit('cancelar', item);
    },
  },
};
</script>
